import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";

type AcceptMemberTermsResponse = {
  version: string;
  date_accepted: string;
  ip_address: string;
};

const ACCEPT_PRIVACY_POLICY_TYPE: string = "accept_member_terms";

export async function acceptUserTerms(
  version: string
): Promise<AcceptMemberTermsResponse> {
  const response = await SocketAsFetch.fetch({
    message_type: ACCEPT_PRIVACY_POLICY_TYPE,
    info: {
      version,
    },
  });
  return response;
}
